import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function changePassword(payload) {
    const options = {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    };

    return axios.post(`${url}/password/update`, payload, options)
        .then(response => response.data);
}

function resetPassword(userId, payload) {
    const options = {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    };

    return axios.post(`${url}/password/reset/${userId}`, payload, options)
        .then(response => response.data);
}

function noneLoginResetPassword(userId, payload) {
    const options = {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    };

    return axios.post(`${url}/password-reset`, payload, options)
        .then(response => response.data);
}
function forceChangePassword(userId, payload) {
    const options = {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    };

    return axios.post(`${url}/password/force-change/${userId}`, payload, options)
        .then(response => response.data);
}

function checkPasswordStrength(payload) {
    const options = {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        }
    };

    return axios.post(`${url}/password/check-strength`, payload, options)
        .then(response => response.data);
}

function getPasswordRequirements() {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json'
        }
    };

    return axios.get(`${url}/password/requirements`, options)
        .then(response => response.data);
}

export default {
    changePassword,
    checkPasswordStrength,
    getPasswordRequirements,
    forceChangePassword,
    resetPassword,
    noneLoginResetPassword
};